// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollToTop_container__1eozp","btn":"ScrollToTop_btn__3g01D","iconStyle":"ScrollToTop_iconStyle__323Ty","moveArrow":"ScrollToTop_moveArrow__3Rg65"};